export default "__VITE_ASSET__DWSmsdRe__"